import React, {  useEffect} from 'react'
import {Link, useHistory} from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { fetchVendorsStart } from '../redux/VendorServices/vendor.actions';
import { useDispatch, useSelector } from 'react-redux';
import Button from './forms/Button'
import DashAuthWrapper from './DashAuthWrapper'
// import CKEditor from 'ckeditor4-react';

const mapState = ({ user, vendorsData }) => ({
	currentUser: user.currentUser,
	services: vendorsData.services
	
})

const CustomersServicesChatDetails = props => {
	const { currentUser, services } = useSelector(mapState);
	const { productName } = useParams();
	const dispatch = useDispatch();
	const history = useHistory();

	const { serviceData } = services;

	useEffect(() => {
		dispatch(
			//filter vendors equal to currentproduct
			fetchVendorsStart(productName)
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []);


	const congfigAuthWrapper = {
		headline: `${productName} Chat`
	}

	return (
		<div>
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper}>

					<div className="cart">

						<table border="0" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td>
									<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
										<tbody>
										<tr>
											<th>
											Vendor Name
											</th>
										
											
											<th >
											Phone
											</th>
											<th >
											Email
											</th>
											<th >
											
											</th>
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td>
									<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									
										{(Array.isArray(serviceData) && serviceData.length > 0) && serviceData.map((vendor, index) => {
										const {
											productName,
											vendorName,
											vendorPhone,
											vendorEmail,
											vendorID
										} = vendor;
										
										return (
											<tr key={index}>
											
											<td>
												{vendorName}
											</td>
											<td>
												<button className="btn" onClick={() => window.open(`tel:${vendorPhone}`)}>Call</button>

											</td>
											<td>
												<button className="btn" onClick={() => window.open(`mailto:${vendorEmail}`)}>Email</button>
											</td>
											<td className="text-right">
												<button className="btn" onClick={() => history.push(`/conversation/${productName}/${vendorID}`)}>Chat</button>
											</td>
											
											</tr>
										)
										})}

									</tbody>
									</table>
								</td>
							</tr>
							
						</tbody>
						</table>

					</div>
					
				
				</DashAuthWrapper>
			)}
		</div>	

	)
}

export default CustomersServicesChatDetails;